import axios from '../axios'
import React, { useEffect,useState } from 'react'
import './Main.css'
import {getFirestore, collection, getDocs} from 'firebase/firestore'
import app from '../firebase'
import asuImg from '../images/asulogo.png'
const Announcements = () => {
    const[announcements, setAnnouncements] = useState([])
    const db = getFirestore(app)
    const collectionRef = collection(db, "announcements")
    useEffect(() => {
        getDocs(collectionRef).then(snapshot => {
            setAnnouncements([ ])
            snapshot.docs.map(doc => {
                setAnnouncements(current => [...current, doc.data()])
            })
        })
    },[db])
  return (
    <div className='announcementContainer'>
        
        <br />
        {announcements.reverse().map(announcement => (
            <div className="announcement">
                <div>
                <h2>{announcement.date} - {announcement.title}</h2>
                <br />
                <p>
                    {announcement.content}
                </p>
                </div>
            </div>
        ))}
    </div>
  )
}

export default Announcements